import React from 'react';
import * as S from './styles';

interface NavbarRightProps {
	children: React.ReactNode;
}

const NavbarRight = ({ children }: NavbarRightProps) => {
	return <S.Base>{children}</S.Base>;
};

export default NavbarRight;
